import { JSX } from 'react';
import { ActorRefFrom } from 'xstate';
import { PeerReference } from '~/types';
import { peerRefMachine } from './peerReferenceMachine';
import { AddressFormWrapper } from './Wizard/AddressWrapper';
import { JSONFormWrapper } from './Wizard/JSONFormWrapper';
import { EndPage } from './Wizard/LastPage';
import { PersonalForm } from './Wizard/PeerReferencePersonalForm';
import { Welcome } from './Wizard/Welcome';
export const defaultPeerReference: PeerReference = {
  id: -1,
  firstName: '',
  lastName: '',
  emailAddress: '',
  phoneNum: '',
  relationshipType: 'Colleague',
  shareFormFlag: false,
  requestDate: '',
  referenceDate: '',
  referenceUniqueCode: '',
  peerReferenceFormId: -1,
  formInstanceId: -1,
  jsonForm: {
    id: -1,
    formDescription: '',
    jsonForm: JSON.parse('{}'),
    jsonFormUi: JSON.parse('{}'),
    formType: 'peer_reference',
  },
};

export interface WizardProps {
  actor: ActorRefFrom<typeof peerRefMachine>;
}
export const WizardSteps: PeerRefStep[] = [
  {
    component: Welcome,
  },
  {
    component: PersonalForm,
  },
  {
    component: AddressFormWrapper,
  },
  {
    component: JSONFormWrapper,
  },
  {
    component: EndPage,
  },
];

export interface PeerRefStep {
  component: (props: WizardProps) => JSX.Element;
}
